import { useFeatureFlag } from "configcat-react";

import { FeatureToggleKey, FeatureToggleKeyMap } from "./use-feature-toggle.types";

export const useFeatureToggle = ({
  featureKey,
  defaultValue,
}: {
  featureKey: FeatureToggleKey;
  defaultValue?: boolean;
}) => {
  return useFeatureFlag(FeatureToggleKeyMap[featureKey], defaultValue || false);
};
